export const CAN_USER_WRITE_PARTNERS = "CAN_USER_WRITE_PARTNERS";
export const COMPUTE_CAN_USER_WRITE_PARTNERS_PERMISSION =
  "COMPUTE_CAN_USER_WRITE_PARTNERS_PERMISSION";
export const CRM_GROUPS_WITH_WRITE_PERMISSION =
  "CRM_GROUPS_WITH_WRITE_PERMISSION";
export const COMPUTE_CRM_GROUPS_WITH_WRITE_PERMISSION =
  "COMPUTE_CRM_GROUPS_WITH_WRITE_PERMISSION";
export const HAS_HIDDEN_BOOKINGS = "HAS_HIDDEN_BOOKINGS";
export const COMPUTE_HAS_HIDDEN_BOOKINGS = "COMPUTE_HAS_HIDDEN_BOOKINGS";
